import React from "react";

export default function SalesMoreFilters({ register, setValue, filterData }) {
  const options = [
    {
      id: "90_days",
      value: "90 days ago",
      label: "Past 90 days",
      backgroundColor: "#67773F",
      textColor: "white",
    },
    { id: "past_year", value: "past year", label: "Past year" },
    { id: "2_year", value: "past 2 years", label: "Past 2 year" },
    { id: "5_year", value: "past 5 years", label: "Past 5 year" },
    { id: "10_year", value: "past 10 years", label: "Past 10 year" },
    { id: "15_year", value: "past 15 year", label: "Past 15 year" },
  ];
  return (
    <>
      <div className="col half_flex_form">
        <div className="form_blk padding_right_span">
          <div className="info_lbl_lbl">
            <h6>Sales date</h6>
            <div className="span_type_lbl">
              <span
                className={`btn_sm_span ${
                  filterData?.sale_date_within === "yes" ? "fil_btn" : ""
                }`}
                onClick={() => setValue("sale_date_within", "yes")}
              >
                Within
              </span>
              <span
                className={`btn_sm_span ${
                  filterData?.sale_date_within === "no" ? "fil_btn" : ""
                }`}
                onClick={() => setValue("sale_date_within", "no")}
              >
                Not within
              </span>
            </div>
          </div>
          <div className="boolean_flex">
            {options.map((option) => (
              <div className="lbl_btn" key={option.id}>
                <input
                  type="radio"
                  id={option.id}
                  value={option.value}
                  {...register("sale_date")}
                  className="hidden"
                />
                <label
                  htmlFor={option.id}
                  className={`site_btn blank yellow_blank main_color ${
                    filterData?.sale_date === option.value ? "active" : ""
                  }`}
                >
                  <span>{option.label}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col half_flex_form">
        <div className="form_blk range_slide">
          <div className="info_lbl_lbl">
            <h6>Sale price</h6>
          </div>
          <div className="half_flex">
            <div className="half_field">
              <input
                type="text"
                name="min_sales_price"
                id="min_sales_price"
                className="input"
                placeholder="Min"
                {...register("min_sales_price")}
              />
            </div>
            <span></span>
            <div className="half_field">
              <input
                type="text"
                name="max_sales_price"
                id="max_sales_price"
                className="input"
                placeholder="Max"
                {...register("max_sales_price")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col half_flex_form">
        <div className="form_blk range_slide">
          <div className="info_lbl_lbl">
            <h6>Sales price/SF</h6>
          </div>

          <div className="half_flex">
            <div className="half_field">
              <input
                type="text"
                name="min_sales_price_sf"
                id="min_sales_price_sf"
                className="input"
                placeholder="Min"
                {...register("min_sales_price_sf")}
              />
            </div>
            <span></span>
            <div className="half_field">
              <input
                type="text"
                name="max_sales_price_sf"
                id="max_sales_price_sf"
                className="input"
                placeholder="Max"
                {...register("max_sales_price_sf")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col half_flex_form">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Sale price/Acres</h6>
          </div>
          <div className="half_flex">
            <div className="half_field">
              <input
                type="text"
                name="min_sales_price_acr"
                id="min_sales_price_acr"
                className="input"
                placeholder="Min"
                {...register("min_sales_price_acr")}
              />
            </div>
            <span></span>
            <div className="half_field">
              <input
                type="text"
                name="max_sales_price_acr"
                id="max_sales_price_acr"
                className="input"
                placeholder="Max"
                {...register("max_sales_price_acr")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
